import { useEffect, useState } from "react";
import is from "@sindresorhus/is";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

import { useTheme } from "@mui/material/styles";

import PhoneOutline from "../../../icons/PhoneOutline";

import actions from "../../../data/actions";

const BeforeHeader = props => {
  const theme = useTheme();
  const [phoneNumber, setPhoneNumber] = useState();

  const bgcolor = theme.palette.primary.main;
  const color = theme.palette.text.primary;

  // (init) -> phoneNumber
  useEffect(() => {
    Promise.resolve()
      .then(() => actions.getPhoneNumberPost())
      .then(post => is.plainObject(post) && setPhoneNumber(post.content.plain.join(", ")))
      .catch(error => console.log(error));
  }, []);

  return (
    <Paper elevation={0} square sx={{ bgcolor, color }}>
      <Container disableGutters maxWidth="lg">
        <Box sx={{ alignItems: "flex-end", display: "flex", flexDirection: "column", px: 2, py: 0.5 }}>
          {is.nonEmptyString(phoneNumber) ? (
            <Box sx={{ alignItems: "center", display: "flex" }}>
              <PhoneOutline fontSize="inherit" sx={{ pr: 1 }} />
              <Typography align="right" variant="body2">
                {phoneNumber}
              </Typography>
            </Box>
          ) : (
            <Typography align="right" component="div" variant="body2">
              &nbsp;
            </Typography>
          )}
        </Box>
      </Container>
    </Paper>
  );
};

export default BeforeHeader;
